import React, { useState } from 'react';

import ReviewPossibleList from '../../user/ReviewPossibleList';
import ReviewList from '../../user/ReviewList';
import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';

import { ReviewPageBanner } from '../../../domain/Review/List/ReviewList';
import ThemeStyle from '../../../lib/style/ThemeStyle';
import WithLoading from '../../../Hoc/WithLoading';
import PageTemplate from './PageTemplate';
import { MYPAGE_REVIEW_MENU } from '../../../lib/routes/MyPageRoutes';
import { useGetReviewList } from '../../../Hooks/useReview';

const ReviewListTemplate = () => {
  const [isFirstTab, setIsFirstTab] = useState(true);
  const { totalLikes, userReviews } = useGetReviewList();

  return (
    <PageTemplate title={MYPAGE_REVIEW_MENU.label} noMargin>
      <Flex column alignItems="stretch" padding="1.25rem 0 0">
        <ReviewPageBanner />
        <Flex
          padding="1.5625rem 0 0"
          style={{
            borderBottom: `1px solid ${ThemeStyle.color.pinkishGrey}`,
          }}
        >
          {['미작성 리뷰', '작성한 리뷰'].map((tab, idx) => (
            <Flex
              key={idx}
              width="100%"
              onClick={() => setIsFirstTab(idx === 0)}
            >
              <Text
                size={16}
                color={
                  (idx === 0 ? isFirstTab : !isFirstTab)
                    ? 'orangePink'
                    : 'brownGrey'
                }
                textAlign="center"
                style={{
                  borderBottom: (idx === 0 ? isFirstTab : !isFirstTab)
                    ? `3px solid ${ThemeStyle.color.orangePink}`
                    : 'none',
                  width: '10rem',
                  paddingBottom: '0.469rem',
                }}
              >
                {tab}
              </Text>
            </Flex>
          ))}
        </Flex>
        {isFirstTab ? (
          <WithLoading
            url="/review/purchased-items/reviewable"
            component={ReviewPossibleList}
          />
        ) : (
          <ReviewList
            userReviews={userReviews}
            totalLikes={totalLikes}
            setIsFirstTab={() => {
              setIsFirstTab(true);
              window.scrollTo(0, 0);
            }}
          />
        )}
      </Flex>
    </PageTemplate>
  );
};

export default ReviewListTemplate;
